export default __webpack_public_path__ + "static/media/chrome-webstore.fcb25146.png";